export { RichSelectModule } from "./richSelectModule";
